/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from "react";
import { ArchetypeDiscovery } from "@dimensional-engineering/dimensional-models";

import styles from "./Archetypes.module.css";

import { AppArchetype } from "./Archetype";
import { ArchetypeUnknownApp } from "./ArchetypeUnknown";
import { useModalContext } from "@/context/ModalContext";
import ArchetypeModal from "../../TraitsModals/Archetype/ArchetypeModal";
import { archetypeDiscoveryMap } from "@/assets/traitInfo/dimensionData";
import ResultsHeading from "@/components/results/ResultsHeading/ResultsHeading";

type ArchetypesProps = {
  archetypes: ArchetypeDiscovery[];
  username: string | undefined;
  uid: string | null;
  onUnknownClick: (slugs: string[]) => void;
};

export default function AuthArchetypes(props: ArchetypesProps) {
  const leftOutArchs = useLeftoutArchetypes({ archetypes: props.archetypes });
  const { setModalComponent } = useModalContext();

  const mapped = props.archetypes
    .filter((a) => a.archetype.archetypeGroupSlug !== "spirit")
    .filter((a) => a.archetype.archetypeGroupSlug !== "values")
    .map((arch, index) => {
      return (
        <div
          onClick={() =>
            setModalComponent(<ArchetypeModal slug={arch.archetypeSlug} />)
          }
          style={{ cursor: "pointer" }}
          key={index}
        >
          <AppArchetype {...arch} />
        </div>
      );
    });

  const nonDiscoveredMap = leftOutArchs.map((l, i) => {
    return (
      <div
        onClick={() => {
          console.log(l);
          props.onUnknownClick(
            archetypeDiscoveryMap[l as keyof typeof archetypeDiscoveryMap]
          );
        }}
        key={i}
      >
        <ArchetypeUnknownApp locked={false} name={l} />
      </div>
    );
  });

  return (
    <div className={styles.archetypesMain}>
      <ResultsHeading title="Archetypes" />
      <div className={styles.archetypesParent}>
        {props.archetypes && mapped}
        {nonDiscoveredMap}
      </div>
    </div>
  );
}

function useLeftoutArchetypes(props: { archetypes: ArchetypeDiscovery[] }) {
  const [leftOutArchs, setLeftOutArchs] = useState<string[]>([]);

  useEffect(() => {
    let has = [];
    let leftOut = [];
    for (let i = 0; i < props.archetypes.length; i++) {
      has.push(props.archetypes[i].dimensionSlug);
    }
    // if (!has.includes("values")) {
    //   leftOut.push("values");
    // }
    if (!has.includes("identity")) {
      leftOut.push("cognition");
    }
    if (!has.includes("love")) {
      leftOut.push("love");
    }
    if (!has.includes("work")) {
      leftOut.push("interaction");
    }
    if (!has.includes("career")) {
      leftOut.push("career");
    }

    setLeftOutArchs(leftOut);
  }, [props.archetypes]);

  return leftOutArchs;
}
